module.exports = __webpack_public_path__ + "img/customer-sysm.f89aef1c.jpg";